const styles = () => ({
  textsize14medium: {
    fontSize: '14px',
    fontWeight: '500',
  },
  searchInputHolder: {
    padding: '0',
    marginBottom: '20px',
    '& fieldset': {
      display: 'none',
    },
    '& > div': {
      padding: '0 !important',
      alignItems: 'flex-end',
    },
    '& input': {
      borderBottom: '1px solid #8C9099',
      fontSize: '14px',
    },
  },
  searchIcon: {
    marginRight: '11px',
  },
  checkboxholder: {
    fontSize: '14px',
    '& input': {
      '&:checked + div': {
        color: '#1FCACC',
      },
    },
  },
  searchitemList: {
    paddingLeft: '0',
    '& li': {
      paddingLeft: '0',
    },
  },
});

export default styles;
